import React, { Component } from 'react';
import SettingsView from './SettingsView';

export default () => (
    <div className="main-settings-wrapper">
        <SettingsView/>
    </div>
);
